import {JsonProperty} from 'json-typescript-mapper';

export class AccountedMarketdateBooth {

  @JsonProperty('id')
  public id?: string;

  @JsonProperty('mbId')
  public mbId?: number;

  @JsonProperty('mbContactPersonId')
  public mbContactPersonId?: number;

  @JsonProperty('accountedAt')
  public accountedAt?: string;

  @JsonProperty('cpId')
  public cpId?: number;

  @JsonProperty('cpFirstname')
  public cpFirstname?: string;

  @JsonProperty('cpLastname')
  public cpLastname?: string;

  @JsonProperty('cpMobile')
  public cpMobile?: string;

  @JsonProperty('cpCasFunction')
  public cpCasFunction?: string;

  @JsonProperty('cpStatus')
  public cpStatus?: string;

  @JsonProperty('meId')
  public meId?: string;

  @JsonProperty('meCompany')
  public meCompany?: string;

  @JsonProperty('meCompanyAdditional')
  public meCompanyAdditional?: string;

  @JsonProperty('meMerchantNumber')
  public meMerchantNumber?: string;

  @JsonProperty('mdateId')
  public mdateId?: string;

  @JsonProperty('mdayId')
  public mdayId?: string;

  @JsonProperty('mplaceId')
  public mplaceId?: string;

  @JsonProperty('mpCity')
  public mpCity?: string;

  @JsonProperty('mbBranchid')
  public mbBranchid?: string;

  @JsonProperty('mplaceBranchString')
  public mplaceBranchString?: string;

  @JsonProperty('mplaceFederalState')
  public mplaceFederalState?: string;

  @JsonProperty('federalState')
  public federalState?: string;

  constructor() {
    this.id = void 0;
    this.mbId = void 0;
    this.mbContactPersonId = void 0;
    this.accountedAt = void 0;
    this.cpId = void 0;
    this.cpFirstname = void 0;
    this.cpLastname = void 0;
    this.cpMobile = void 0;
    this.cpCasFunction = void 0;
    this.cpStatus = void 0;
    this.meId = void 0;
    this.meCompany = void 0;
    this.meCompanyAdditional = void 0;
    this.meMerchantNumber = void 0;
    this.mdateId = void 0;
    this.mdayId = void 0;
    this.mplaceId = void 0;
    this.mpCity = void 0;
    this.mbBranchid = void 0;
    this.mplaceBranchString = void 0;
    this.mplaceFederalState = void 0;
    this.federalState = void 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/entities/accounted-marketdate-booth.model.ts